import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Dossier } from "src/app/suivi-portefeuille/core/model/dossier";
import { DossierService } from "src/app/suivi-portefeuille/core/service/dossier.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Echeance } from "src/app/suivi-portefeuille/core/model/echeance";
import { Paiement } from "src/app/suivi-portefeuille/core/model/paiement";
import { EcheanceService } from "src/app/suivi-portefeuille/core/service/echeance.service";
import { PaiementService } from "src/app/suivi-portefeuille/core/service/paiement.service";
import { Request } from "src/app/parametrage/core/model/request";
interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-echeance-tab",
  templateUrl: "./echeance-tab.component.html",
  styleUrls: ["./echeance-tab.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class EcheanceTabComponent implements OnInit {
  pressButton: Boolean = false;

  alerts: Alert[] = [];

  dossier: Dossier;
  requestEncours: Request;

  numDossier: number;
  echeances: Echeance[];

  paiements: Paiement[];
  paiementArray: Array<Paiement[]> = [];

  displayedStudentsColumnsList: string[] = [
    "numEcheance",
    "montantEcheance",
    "dateEcheance",
    "statutEcheance",
    "actions",
  ];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private _dossierService: DossierService,
    private _echeanceService: EcheanceService,
    private _paiementService: PaiementService,
    private _requestService: RequestService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.numDossier = params["numDossier"];
      this.getDossierByNumDossier(this.numDossier);
      this.getEcheanceListByNumDossier(this.numDossier);
      this.getRequestEncoursAttentePaiementByNumDossier(this.numDossier);
    });
  }

  getDossierByNumDossier(numDossier) {
    this._dossierService.getDossierByNumDossier(numDossier).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getEcheanceListByNumDossier(numDossier) {
    this._echeanceService.getEcheanceListByNumDossier(numDossier).subscribe(
      (data) => {
        this.echeances = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getPaiementListByNumEcheance(numEcheance) {
    this._paiementService.getPaiementListByNumEcheance(numEcheance).subscribe(
      (data) => {
        this.paiements = data;
        this.paiementArray[numEcheance] = this.paiements;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRequestEncoursAttentePaiementByNumDossier(numDossier) {
    this._requestService
      .getRequestEncoursAttentePaiementByNumDossier(numDossier)
      .subscribe(
        (data) => {
          this.requestEncours = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  analyserDossier() {
    this._dossierService.analyserDossier(this.numDossier).subscribe(
      (data1) => {
        this.alerts.push({
          type: "success",
          message: "Analyse efféctuée",
        });

        this.getDossierByNumDossier(this.numDossier);
        this.getEcheanceListByNumDossier(this.numDossier);
        this.getRequestEncoursAttentePaiementByNumDossier(this.numDossier);
      },
      (error1) => {
        console.log(error1);
        this.alerts.push({
          type: "danger",
          message: error1.error.message,
        });
      }
    );
  }

  lancerProcedure() {
    this._dossierService.lancerProcedure(this.numDossier).subscribe(
      (data1) => {
        this.alerts.push({
          type: "success",
          message: "Dossier lancer",
        });
        this.requestEncours = data1;
      },
      (error1) => {
        this.alerts.push({
          type: "danger",
          message: error1.error.message,
        });
        console.log(error1);
      }
    );
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
}
